import React, { Suspense, useEffect, useState } from "react";
import './FileIcon.scss';
import DocSVG from '../../assets/img/file_ext/doc.svg';

export const FileExtPath = '../../assets/img/file_ext';

export const EXT_LIST = {
    default: DocSVG,
};

export const ICON_FILE_LIST = {
    'aac':  () => import('../../assets/img/file_ext/aac.svg'),
    'ace':  () => import('../../assets/img/file_ext/ace.svg'),
    'ai':   () => import('../../assets/img/file_ext/ai.svg'),
    'aut':  () => import('../../assets/img/file_ext/aut.svg'),
    'avi':  () => import('../../assets/img/file_ext/avi.svg'),
    'bin':  () => import('../../assets/img/file_ext/bin.svg'),
    'bmp':  () => import('../../assets/img/file_ext/bmp.svg'),
    'cad':  () => import('../../assets/img/file_ext/cad.svg'),
    'cdr':  () => import('../../assets/img/file_ext/cdr.svg'),
    'css':  () => import('../../assets/img/file_ext/css.svg'),
    'db':   () => import('../../assets/img/file_ext/db.svg'),
    'dmg':  () => import('../../assets/img/file_ext/dmg.svg'),
    'doc':  () => import('../../assets/img/file_ext/doc.svg'),
    'docx': () => import('../../assets/img/file_ext/docx.svg'),
    'dwf':  () => import('../../assets/img/file_ext/dwf.svg'),
    'dwg':  () => import('../../assets/img/file_ext/dwg.svg'),
    'eps':  () => import('../../assets/img/file_ext/eps.svg'),
    'exe':  () => import('../../assets/img/file_ext/exe.svg'),
    'flac': () => import('../../assets/img/file_ext/flac.svg'),
    'gif':  () => import('../../assets/img/file_ext/gif.svg'),
    'hlp':  () => import('../../assets/img/file_ext/hlp.svg'),
    'htm':  () => import('../../assets/img/file_ext/htm.svg'),
    'html': () => import('../../assets/img/file_ext/html.svg'),
    'ini':  () => import('../../assets/img/file_ext/ini.svg'),
    'iso':  () => import('../../assets/img/file_ext/iso.svg'),
    'java': () => import('../../assets/img/file_ext/java.svg'),
    'jpg':  () => import('../../assets/img/file_ext/jpg.svg'),
    'js':   () => import('../../assets/img/file_ext/js.svg'),
    'mkv':  () => import('../../assets/img/file_ext/mkv.svg'),
    'mov':  () => import('../../assets/img/file_ext/mov.svg'),
    'mp3':  () => import('../../assets/img/file_ext/mp3.svg'),
    'mp4':  () => import('../../assets/img/file_ext/mp4.svg'),
    'mpg':  () => import('../../assets/img/file_ext/mpg.svg'),
    'pdf':  () => import('../../assets/img/file_ext/pdf.svg'),
    'php':  () => import('../../assets/img/file_ext/php.svg'),
    'png':  () => import('../../assets/img/file_ext/png.svg'),
    'ppt':  () => import('../../assets/img/file_ext/ppt.svg'),
    'ps':   () => import('../../assets/img/file_ext/ps.svg'),
    'psd':  () => import('../../assets/img/file_ext/psd.svg'),
    'rar':  () => import('../../assets/img/file_ext/rar.svg'),
    'rss':  () => import('../../assets/img/file_ext/rss.svg'),
    'rtf':  () => import('../../assets/img/file_ext/rtf.svg'),
    'svg':  () => import('../../assets/img/file_ext/svg.svg'),
    'swf':  () => import('../../assets/img/file_ext/swf.svg'),
    'sys':  () => import('../../assets/img/file_ext/sys.svg'),
    'tiff': () => import('../../assets/img/file_ext/tiff.svg'),
    'txt':  () => import('../../assets/img/file_ext/txt.svg'),
    'xls':  () => import('../../assets/img/file_ext/xls.svg'),
    'xlsx': () => import('../../assets/img/file_ext/xlsx.svg'),
    'zip':  () => import('../../assets/img/file_ext/zip.svg'),
};

(() => {
    for (const ext in ICON_FILE_LIST) {
        EXT_LIST[ext] = ICON_FILE_LIST[ext];
    }
})();

const FileIcon = ({
    fileType
}) => {
    const resourceToLoad = EXT_LIST[fileType];
    const [resourceURL, setResourceURL] = useState(false);
    const [isValidFormat, setIsValidFormat] = useState(resourceToLoad ? true : false);
    let defaultImg = <img src={EXT_LIST['default']} className="fext-icon"/>;
    useEffect(() => {
        if (!isValidFormat) return;
        if (typeof resourceToLoad != 'function') {
            setResourceURL(resourceToLoad);
            return;
        }
        const loadResourceToLoad = async function () {
            const pkg = await (resourceToLoad());
            const url = pkg.default;
            EXT_LIST[fileType] = url;
            setResourceURL(url);
        };
        loadResourceToLoad();
    }, [isValidFormat]);
    if (!isValidFormat) {
        return defaultImg;
    }
    return (
        resourceURL ?
            <img src={resourceURL} className="fext-icon"/> :
            <div className="loader" style={{width: 50, height: 50, borderWidth: 4}} />
    );
};

export default FileIcon;